// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingOutlinedSvg from "@ant-design/icons-svg/es/asn/ShoppingOutlined";
import AntdIcon from '../components/AntdIcon';

var ShoppingOutlined = function ShoppingOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingOutlinedSvg
  }));
};

ShoppingOutlined.displayName = 'ShoppingOutlined';
export default React.forwardRef(ShoppingOutlined);